import { useEffect, useState } from 'react';

import format from 'date-fns/format';
import isEqual from 'date-fns/isEqual';
import parse from 'date-fns/parse';

type UseCombineInputValueParams = {
  valueFromRHF?: Date;
  defaultValue?: Date;
  inputPropsValue: string;
  formatStr: string;
  isRHFConnected?: boolean;
};

/** To make focus stay in place when type value manually, focus is going to be placed at the end
 * if we use value not from onChange event.target.value */
export const useCombineInputValue = ({
  valueFromRHF,
  defaultValue,
  inputPropsValue,
  formatStr,
  isRHFConnected,
}: UseCombineInputValueParams) => {
  const [value, setValue] = useState(
    (valueFromRHF && format(valueFromRHF, formatStr)) ||
      (defaultValue && format(defaultValue, formatStr)) ||
      inputPropsValue
  );

  useEffect(() => {
    setValue(inputPropsValue);
  }, [inputPropsValue]);

  useEffect(() => {
    if (isRHFConnected) {
      if (valueFromRHF) {
        const formattedRHFDate = format(valueFromRHF, formatStr);
        const parsedInputDate = parse(inputPropsValue, formatStr, new Date());

        /** Should check equality of dates not formatted string since after format date(of valueFromRHF)
         *  will turn from 06/1/202 to 06/01/0202 */
        if (!isEqual(valueFromRHF, parsedInputDate)) {
          setValue(formattedRHFDate);
        }
      } else setValue('');
    }
  }, [valueFromRHF]);

  return value;
};
